// Proveedores de tracking de contenedores. Hoy el tracking es ShipsGo; FindTEU
// quedó guardado sin desplegar en supabase/providers-disabled/findteu (ver su
// README para reactivarlo).
export const FINDTEU_TRACKING_ENABLED = false;
